<template>
  <div>
    <!-- <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
      OTP
    </div> -->
    <div v-if="loading">
      <div class="text-center pt-10">
        <v-progress-circular color="primary" indeterminate size="60"></v-progress-circular>
      </div>
    </div>
    <div v-else class="pa-5">
      <div class="mb-0">
        <v-btn @click="$emit('close')" text color="primary">
          <v-icon>mdi-chevron-left</v-icon>
          กลับ
        </v-btn>
      </div>
      <div class="text-center my-4 mb-6">ระบบส่งรหัส OTP ไปที่เลขหมาย</div>
      <div class="text-center">{{ phone }}</div>
      <div class="text-center border-bottom mb-2">ref: {{ ref }}</div>
      <div class="text-center my-4 mb-6">กรอกรหัส OTP เพื่อยืนยันตัวตน</div>

      <ValidationObserver ref="observer">
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="OTP"
          v-slot="{ errors }"
        >
          <custom-input v-model="input.otp" :center="true" placeholder="OTP" numberOnly outlined :error-messages="errors"></custom-input>
        </ValidationProvider>
      </ValidationObserver>
      <div class="text-center mb-2">
        <span v-if="showCountdowntimer" class="mr-2">นับเวลาถอยหลัง</span>
        <CountDownTimer style="font-size: 22px" v-if="showCountdowntimer" :startmin="timeleft" @ontimeout="showCountdowntimer = false"></CountDownTimer>
        <div v-else>OTP หมดอายุ</div>
      </div>

      <div class="mt-4">
        <v-btn :loading="saveloading" @click="submitOtp" style="font-size: 22px" class="text-capitalize" color="primary" dark block>ยืนยัน</v-btn>
        <v-btn class="mt-2 w-100" style="font-size: 22px" @click="resendotp">ขอรหัส OTP อีกครั้ง</v-btn>
      </div>
    </div>
    <v-dialog width="350px" v-model="showCooldownTimeDialog">
      <v-card v-if="showCooldownTimeDialog" class="Kanit pa-4">
        <div class="text-center">
          เนื่องจากคุณได้รับรหัส OTP ไปแล้ว กรุณากรอกรหัส OTP อีกครั้งหลังจากเวลา
        </div>
        <div class="text-center">
          <CountDownTimer
            style="font-size: 22px"
            v-if="showCountdowntimer"
            :startmin="timeleft"
            @ontimeout="
              showCountdowntimer = false;
              showCooldownTimeDialog = false;
            "
          ></CountDownTimer>
          <span v-else style="font-size: 22px">00:00</span>
          <div class="text-center mt-2">
            <v-btn @click="showCooldownTimeDialog = false" color="primary">ปิด</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import CountDownTimer from "@/components/CountDownTimer.vue";
export default {
  components: {
    CountDownTimer,
  },
  data() {
    return {
      timeleft: 0,
      showCountdowntimer: false,
      showCooldownTimeDialog: false,
      loading: false,
      saveloading: false,
      ref: "",
    };
  },
  computed: {
    input() {
      return this.$store.state.input;
    },
    xxxphone() {
      return this.$store.state.member.phoneNumber.slice(this.$store.state.member.phoneNumber.length - 4);
    },
    phone() {
      return this.$store.state.member.phoneNumber;
    },
  },
  async mounted() {
    this.input.otp = "";
    var isOTPready = await this.$store.dispatch("isOTPready");

    if (isOTPready.status) {
      this.showCountdowntimer = false;

      await this.getOtp();
      this.timeleft = 3;
      this.showCountdowntimer = true;
    } else {
      this.ref = this.$store.state.cachesReferral;
      this.timeleft = isOTPready.timeleft;
      this.showCountdowntimer = true;
      this.showCooldownTimeDialog = true;
    }
  },
  methods: {
    resendotp() {
      this.getOtp();
    },
    getOtp() {
      const vm = this;
      return new Promise((resolve) => {
        var data = {
          userid: vm.userid,
          pageid: vm.query.pageid,
          phoneNumber: vm.phone,
        };
        vm.loading = true;
        axios
          .post(vm.serverUrl + "toacrm/request-otp", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            vm.loading = false;
            if (response.data.responsecode == 200) {
              vm.ref = response.data.data[0].referral;
              vm.$store.state.cachesReferral = response.data.data[0].referral;
            } else if (response.data.response == 204) {
              vm.$swal.fire({ text: response.data.reason });
            } else {
              await vm.$swal.fire({ text: response.data.reason });
              vm.$liff.closeWindow();
            }
            resolve();
          });
      });
    },
    submitOtp() {
      const vm = this;
      return new Promise(async (resolve) => {
        const identity_number_image = this.$store.state.cachesImageUrl;
        let data = {
          otp: this.input.otp,
          ref: this.ref,
          user_id: this.userid,
          page_id: this.query.pageid,
          member_id: this.$store.state.member.memberId, // required
          identity_number_image: identity_number_image,
        };

        vm.saveloading = true;
        const url = `${vm.serverUrl}toacrm/api/liff/upload-id-card-image-with-otp`;
        try {
          const response = await axios.put(url, data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          });

          if (response && response.status === 200) {
            await vm.$swal.fire({
              icon: "success",
              text: "อัปโหลดรูปบัตรประชาชนสำเร็จ",
            });
            vm.$emit("close");
          } else {
            vm.$swal.fire({
              type: "error",
              text: "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง",
            });
          }
        } catch (error) {
          if (error?.response?.data?.message) {
            this.$swal.fire({
              type: "error",
              text: error.response.data.message,
            });
          }
        }
      });
    },
  },
};
</script>
<style></style>
